export class FilterTypesRequest{
    type :string
}